// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../../../generated-types'

import gql from 'graphql-tag'
export type ResponseMapFragment = {
  __typename?: 'Venue'
  longitude?: number | null
  latitude?: number | null
  nearestTransit?: {
    __typename?: 'NearestTransit'
    distance_km: number
    station: string
  } | null
}

export const ResponseMapFragmentDoc = gql`
  fragment ResponseMap on Venue {
    longitude
    latitude
    nearestTransit {
      distance_km
      station
    }
  }
`
